import React, {Component} from "react";
import {ocrIdCardImageService} from "../../services/ocrImage/OcrIdCardImageService";
import {Divider, Empty, Image, Spin} from "antd";

class CustomerIdCardOcr extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);
        this.initState = {
            idCardNumber: "",
            idCardImage: "",

            displayLoading: false,
            displayDataImage: false,
            displayNoImage: false,
            displayErrorResponse: false,
            dataResult: {},
        }
        this.state = {...this.initState}
    }

    fetchOcrIdCardImage = async () => {
        if (!this.state.idCardImage) {
            this.setState({
                displayLoading: false,
                displayDataImage: false,
                displayNoImage: true,
                displayErrorResponse: false,
                dataResult: {},
            });
        } else {
            this.setState({
                displayLoading: true,
                displayDataImage: false,
                displayNoImage: false,
                displayErrorResponse: false,
                dataResult: {},
            });

            try {
                const dataOcr = await ocrIdCardImageService.getData({
                    image_url: this.state.idCardImage,
                });
                this.setState({
                    displayLoading: false,
                    displayDataImage: true,
                    dataResult: dataOcr?.data?.data
                });
            } catch (e) {
                this.setState({
                    displayLoading: false,
                    displayErrorResponse: true
                });
            }
        }
    }

    async componentDidMount() {
        await this.promisedSetState({
            idCardNumber: this.props.idCardNumber,
            idCardImage: this.props.idCardImage,
        });
        this.fetchOcrIdCardImage();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.time !== prevProps.time) {
            await this.promisedSetState({
                idCardNumber: this.props.idCardNumber,
                idCardImage: this.props.idCardImage,
            });
            this.fetchOcrIdCardImage();
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <span className={`font-75-grey`}>Id Card Number:</span><br/>
                {this.state.idCardNumber}
                <Divider/>

                <div style={this.state.displayLoading ? {} : {display: 'none'}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>

                <div style={this.state.displayDataImage ? {} : {display: "none"}}>
                    <Image src={this.state.idCardImage}/>
                    <br/><br/>
                    <span className={`font-75-grey`}>JSON Response:</span><br/>
                    <pre>
                        {JSON.stringify(this.state.dataResult, undefined, 3)}
                    </pre>
                </div>

                <div style={this.state.displayNoImage ? {} : {display: "none"}}>
                    <Empty/>
                    No Image URL
                </div>

                <div style={this.state.displayErrorResponse ? {} : {display: "none"}}>
                    Error Response
                </div>
            </React.Fragment>
        );
    }
}

export default CustomerIdCardOcr;
